import React, { useEffect, useState } from 'react'
import { makeStyles,Dialog } from "@material-ui/core";
import { embedDashboard } from 'amazon-quicksight-embedding-sdk';
import Loader from "react-loader-spinner";

import { Endpoint, isAdmin } from '../../api/base'
import CustomLoader from '../../components/CustomLoader';
import { getUserProfileTokenName } from '../../components/shared/helpers/helper';


const useStyles = makeStyles((theme)=>({
    dashboardContainer:{
        width:"99%",
        marginLeft:"auto",
        marginRight:"auto",
        minHeight:"100vh",
        
    }
}))

function Dashboard() {
    const classes= useStyles()
    const dashboardRef = React.createRef();
    const [loader,setLoader]=useState(true)
    const getDashboard = async () => {
        const options = {
            url: "url to be replaced",
            container: dashboardRef.current,
            width: "100%",
            scrolling: "no",
            height: "AutoFit",
           footerPaddingEnabled: true
        };
        const user = JSON.parse(localStorage.getItem(getUserProfileTokenName()));
        const response = await Endpoint.quicksightDashboard({
            "UserName": user?.user_name,
            "Email": user?.email,
            "Sub": user["sub"],
            "reader_admin":isAdmin()?"ADMIN":"READER"
        })
        options.url=response.data
       let dashboard = embedDashboard(options)
       dashboard.on('error',(err)=>{console.log(err);setLoader(false)})
       dashboard.on('load',(load)=>{console.log(load);setLoader(false)})
    };
    useEffect(()=>{
        getDashboard()
        
    },[])

    return (
        <div className={classes.dashboardContainer} style={{position:"relative"}} id="parent-div">
            
            <div ref={dashboardRef}></div>
            {
                loader ? <Loader
                style={{
                  margin: "0",
                  position: "absolute",
                  top: "50%",
                  msTransform: "translateY(-50%)",
                  transform: "translateY(-50%)",
                  left: "50%",
                }}
                  type="Puff"
                  color="#00BFFF"
                  height={100}
                  width={100}
                  timeout={50000}
                /> : null
            }
            {/* <Dialog open={loader} style={{position: 'absolute'}} BackdropProps={{ style: { position: 'absolute' } }}
            container={document.getElementById('parent-div')}>{loader === true ? <CustomLoader /> : null}</Dialog> */}
            
        </div>
    )
}

export default Dashboard
